export class AdministrativeArea {
  constructor(readonly area_name: string, readonly return_period: number) {}
}
